/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAI-format tool call — mirrors the agent-router's `ToolCall` (conversation/llm-client.ts).
 * Stored in `ChatMessage.llm_payload` on `ASSISTANT_TOOL_CALLS` rows and sent as `tool_calls`
 * on assistant messages in the transcript forwarded to the agent-router.
 */
export type TOpenAiToolCall = {
    function: {
        arguments: string;
        name: string;
    };
    type: TOpenAiToolCall.type;
    id: string;
};
export namespace TOpenAiToolCall {
    export enum type {
        FUNCTION = 'function',
    }
}

